import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/urology-surgeries/$slug")({
  loader: ({ params }) => loadLegacyContent(`urology-surgeries/${params.slug}`),
  head: ({ loaderData, params }) =>
    loaderData
      ? legacyHead(`/urology-surgeries/${params.slug}`, loaderData)
      : { meta: [{ title: "Urology Surgery — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
